import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";
import { BusinessActivitiesReportFilter } from "../types";

export const getBusinessActivitiesReport = (
  user: User,
  filter: BusinessActivitiesReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getbusinessactivitiesreport",
    params: {
      userid: user.userId,
      datefrom: filter.datefrom,
      dateto: filter.dateto,
    },
  });
};

export default getBusinessActivitiesReport;
